<app-section-banner></app-section-banner>
<app-section-pilares></app-section-pilares>
<app-section-numeros-graduadas></app-section-numeros-graduadas>
<app-section-previa-incubadora></app-section-previa-incubadora>
<app-section-previa-projeto></app-section-previa-projeto>

<app-section-empresas [tipo]="tipoEmpresaIncubada"></app-section-empresas>

<app-section-empresas [tipo]="tipoEmpresaMantenedora"></app-section-empresas>

